module.exports = __webpack_public_path__ + "static/media/Copy of _DSC1686.dfd80a28.jpg";